import type {NavigateOptions} from "react-router";
import {SESSION_STORAGE_PREFIX} from "../AuthTypes";

export type LoginRouteState = {
    state: 'LoginRouteState'
    loginIntention: {
        autoLogin: boolean
        onSuccessRedirectTo: string
        onSuccessRedirectOptions?: NavigateOptions
    }
}

export function isLoginRouteState(obj: any): obj is LoginRouteState {
    return obj?.state === 'LoginRouteState';
}

export const LOGIN_STATE_SESSION_KEY = SESSION_STORAGE_PREFIX + 'login_state';
